import { useEffect } from "react";

import { AppStartButton } from "@/components/app-start-link";
import CustomerScreenShell from "@/components/customer-screen-shell";
import { isNativeApp } from "@/lib/native-bridge";
import { useNativeApp } from "@/lib/use-native-app";
import { forgetCustomerLink } from "@/modules/project/ui/customer-links";
import { browserDraftStore } from "@/modules/project/ui/log-draft";
import Notice from "@buildpy/ui/notice";
import { UNUSABLE_LINK_BODY, UNUSABLE_LINK_TITLE } from "@buildpy/core/modules/contract/customer-link-text";

// 없는·회수·만료·파기·해지 링크가 모두 같은 화면이다 — 어느 쪽인지 말하면 토큰의 존재가 새어 나간다 · 앱 안이면 그 토큰을 잊고 처음 화면으로 갈 길을 둔다.
const UnusableLink = ({ token }: { token?: string }) => {
  const native = useNativeApp();
  useEffect(() => {
    if (token && isNativeApp()) forgetCustomerLink(browserDraftStore(), token);
  }, [token]);
  return (
    <CustomerScreenShell>
      <Notice actions={native ? <AppStartButton /> : undefined} body={UNUSABLE_LINK_BODY} title={UNUSABLE_LINK_TITLE} />
    </CustomerScreenShell>
  );
};

export default UnusableLink;
